
const isIE = /*@cc_on!@*/ !!document.documentMode;// eslint-disable-line no-inline-comments, spaced-comment
const elOffset = 110;

function getDistance(el) {
    return new Promise((resolve, reject) => {
        let interval = setInterval(() => {

            if (el.length) {
                const distance = el.offset().top - elOffset;

                clearInterval(interval);
                resolve(distance);
            }
        }, 1000);
    });
}

export default async function sticky_IE_Fix () {

    if (isIE) {
        const el = $('[data-sticky]');
        const distance = await getDistance(el);

        $(window).scroll(function (event) {
            const y = $(this).scrollTop();

            if (y >= distance) {
                el.addClass('is-sticky');
            } else {
                el.removeClass('is-sticky');
            }
        });

    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/ie-fix.js